const handleDeleteFormActions = {
  confirm: 'Deseja realmente apagar essa ação?',
  title: 'APAGAR AÇÃO'
};

export default handleDeleteFormActions;
